import React from 'react';
import Linkify from 'react-linkify';
import { sortBy } from 'lodash';
import Title from '../title';

const LegalDocuments = ({ legalDocuments }) => {
  const groupedDocuments = sortBy(legalDocuments, 'type');
  const renderedDocuments = groupedDocuments.map(renderDocument);
  return (
    <div>{renderedDocuments}</div>
  );
};

const renderDocument = ({ id, title, content, type }) => {
  const key = `legal-document-${id}`;
  return (
    <div className={`legal-document ${type}`} key={key}>
      <Title text={title} bigger className="black mb-4" />
      <Linkify>
        <p>{content}</p>
      </Linkify>
    </div>
  );
};

export default LegalDocuments;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-legal-documents/legal-documents.js